import React from 'react';
import HeaderComp from '../components/HeaderComp';
import { Outlet } from 'react-router-dom';
import ApiInterceptorInitializer from '../components/ApiInterceptorInitializer';

interface DefaultLayoutProps {
  scrollContainerRef?: React.RefObject<HTMLDivElement>;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ scrollContainerRef }) => {
  return (
    <>
    <ApiInterceptorInitializer />
      <HeaderComp />
      <div className="scrollable-container" ref={scrollContainerRef}>
        <div className="container">
          <Outlet /> {/* Renders child routes */}
        </div>
      </div>
    </>
  );
};

export default DefaultLayout;
